import { http } from "../../../services/apiEvaluation/Http.interceptor";
import { CommentInterface, ICommentSubmit } from "./assessment/interface/AssesmentInterface";

const ANSWERURL: string = '/usuarios/avaluaciones';

export const getByAssessment = (id: string) => {
    return http.get<any[]>(`${ANSWERURL}/assesment/${id}`);
}

export const postAssessment = (assessment: any) => {
    return http.post<any[]>(`${ANSWERURL}/assesment`, assessment);
}

export const getAssesments = () => {
  return http.get(`${ANSWERURL}/assesment`)
}

export const updateAssesment = (id:string, assesment: any)  => {
  return http.put(`${ANSWERURL}/assesment/${id}`, assesment)
}

export const getRatingComment = () => {
  return http.get(`${ANSWERURL}/ratingComment`);
}

export const createRatingComment = (comment:ICommentSubmit) => {
  return http.post(`${ANSWERURL}/ratingComment`, comment);
}

export const updateRatingComment = (id:string, comment:CommentInterface) => {
  return http.put(`${ANSWERURL}/ratingComment/${id}`, comment);
}

export const getRatingQuestion = () => {
  return http.get(`${ANSWERURL}/ratingQuestion`);
}


